/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usage_TitleInputs */

const da_usage_title = /** @type {(inputs: Usage_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forbrug`)
};

/** @type {(inputs: Usage_TitleInputs) => LocalizedString} */
const en_usage_title = da_usage_title;

/**

* @param {Usage_TitleInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const usage_title = /** @type {((inputs?: Usage_TitleInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_TitleInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_usage_title(inputs)
	return /** @type {LocalizedString} */ ("Forbrug")
});